module.exports = __webpack_public_path__ + "static/media/boom-papier.cb5625f4.png";